var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 21.5775H0V17.838L1.99307 15.6892V10.7887C1.99307 4.83026 6.4733 0 12 0C17.5266 0 22.0069 4.83026 22.0069 10.7887V15.6904L24 17.8391L24 21.5775ZM2.08698 19.3275H21.913V18.765L19.92 16.6162V10.7888C19.92 6.07293 16.3741 2.25001 12 2.25001C7.6259 2.25001 4.08005 6.07296 4.08005 10.7888V16.6196L2.08698 18.7695V19.3275ZM12 25.92C9.78374 25.9175 7.98636 23.9876 7.97218 21.6014V21.6C7.97124 21.5663 7.97068 21.5267 7.97068 21.4869C7.97068 20.9707 8.06201 20.4776 8.22818 20.0251L8.2195 20.052L10.1666 20.8631C10.0998 21.0465 10.0611 21.2588 10.0611 21.481C10.0611 21.5042 10.0615 21.5274 10.0624 21.5504L10.0623 21.5471V21.5831C10.0623 22.7387 10.9312 23.6756 12.0031 23.6756C13.0751 23.6756 13.944 22.7388 13.944 21.5831V21.5471C13.9448 21.5273 13.9452 21.5042 13.9452 21.4809C13.9452 21.2588 13.9064 21.0465 13.8359 20.8513L13.8397 20.8631L15.7868 20.052C15.9406 20.473 16.0298 20.9606 16.0298 21.4707C16.0298 21.5162 16.0291 21.5614 16.0277 21.6065L16.0278 21.6C16.0136 23.9876 14.2163 25.9175 12.0002 25.92H12H12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotification);
export default __webpack_public_path__ + "static/media/icon-notification.2592cc01315901b1bd0ac605a434a479.svg";
export { ForwardRef as ReactComponent };